import { USER_TYPE } from '@/utils/constants';

import { mapActions, mapState } from 'vuex';

import { currencyFilter, contractorProfileFilter, numberWithPaddingZeros } from '@/utils/filters';

import { setPatchOpportunities } from '@/services/api/opportunities';

import { sendEngelinkAdsClicks } from '@/services/api/marketing';

export default {
    name: 'CardOffer',
    props: {
        data: {
            type: Object,
            required: true,
            default: () => {}
        },
        subscription: {
            type: Object,
            default: () => {}
        },
        isSupplier: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            isMobile: false,
            chartMediumBlueColor: '',
            USER_TYPE: USER_TYPE,
            bpoTooltipText: '',
            proTooltipText: '',
            primeTooltipText: '',
            priorityQuotationTooltipText: ''
        };
    },
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
        const bodyStyles = window.getComputedStyle(document.body);
        this.chartMediumBlueColor = bodyStyles.getPropertyValue('--chart-color--medium-blue').trim();

        this.bpoTooltipText =
            'Cotações administradas por um profissional de suprimentos da Engelink contratado pelo solicitante. É necessário aceitar os termos para participar.';
        this.proTooltipText = 'Cotações onde o contratante disponibilizou um horário para receber uma visita técnica.';
        this.primeTooltipText = 'Cotações que são gratuitas para assinantes do plano Prime.';
        this.priorityQuotationTooltipText = ' Esta cotação está em horário exclusivo de acordo com seus benefícios.';
    },
    methods: {
        currencyFilter,
        contractorProfileFilter,
        numberWithPaddingZeros,
        ...mapActions('supplier', ['addViewedOffer']),
        openDetails(offer) {
            this.addViewedOffer(offer);

            if (this.subscription.canAccessCrmBenefit && this.data.opportunityId && !this.isEnterprise) {
                this.$emit('remove-opportunity', this.data.id);
                setPatchOpportunities(this.data.opportunityId, { unread: false });
            }
            if (this.isSupplier) {
                if (this.isEnterprise) {
                    const routeData = this.$router.resolve({
                        name: 'Enterprise',
                        params: {
                            id: offer.id
                        }
                    });
                    window.open(routeData.href, '_blank');
                }
                if (offer.competitionData.proposal) {
                    const routeData = this.$router.resolve({
                        name: 'proposalDetails',
                        params: {
                            id: offer.id
                        }
                    });
                    window.open(routeData.href, '_blank');
                } else {
                    const routeData = this.$router.resolve({
                        name: 'OffersDetails',
                        params: {
                            tag: offer.tagSlug ? offer.tagSlug : 'outra',
                            id: offer.id
                        }
                    });
                    window.open(routeData.href, '_blank');
                }
            } else {
                const routeData = this.$router.resolve({
                    name: 'OffersDetailsGuest',
                    params: {
                        tag: offer.tagSlug ? offer.tagSlug : 'outra',
                        id: offer.id
                    }
                });
                window.open(routeData.href, '_blank');
            }
        },
        async sendClick(data) {
            window.open(data.urlRedirect, '_blank');
            try {
                await sendEngelinkAdsClicks({
                    campaign: data.campaign,
                    device: data.device,
                    location: data.location,
                    state: data.state,
                    tag: data.tag
                });
            } catch (error) {
                console.error(error);
            }
        }
    },
    computed: {
        ...mapState('user', ['supplierData']),
        ...mapState('supplier', ['viewedOffersIds']),
        isVisited() {
            return this.viewedOffersIds.find(id => id === this.data.id);
        },
        markerIcon() {
            return require('@/assets/images/pin_drop.svg');
        },
        showPrice() {
            return this.subscription.canAccessCrmBenefit;
        },
        isEnterprise() {
            return this.data.competitionData.isEnterprise;
        },
        countdownCard() {
            if (this.isEnterprise) {
                return this.data.participationEnterpriseCountdown;
            } else if (this.data.competitionData.hasSlotExtra) {
                return this.data.participationExtraCountdown;
            } else {
                return this.data.competitionData.participationCountdown;
            }
        },
        typeBannerCard() {
            if (this.hasClosedSlots && this.isSupplier && this.showDontMissTheOpportunity && !this.isExtraSlot) {
                return 'closed';
            } else if (this.data.competitionData.reservedForYou) {
                return 'engelink-marketing';
            } else if (this.isEnterprise) {
                return 'enterprise';
            } else if (this.data.competitionData.hasSlotExtra) {
                return 'extra-slot';
            } else {
                ('competition');
            }
        },
        nameBannerCard() {
            if (this.data.competitionData.reservedForYou) {
                return 'Inteligencia de Mercado';
            } else if (this.data.competitionData.isEnterprise) {
                return 'Engelink Enterprise';
            } else if (this.data.competitionData.hasSlotExtra) {
                return 'Oportunidade Exclusiva';
            } else {
                return 'Cotação Validada';
            }
        },
        showStatusCard() {
            return this.subscription.isActive && this.isSupplier && !this.isEnterprise;
        },
        showDontMissTheOpportunity() {
            return this.subscription.isActive && this.supplierData.canBuyQuotationCreditCard;
        },
        freeOffer() {
            return this.freeSubscription || this.freeNotSubscription;
        },
        freeNotSubscription() {
            return (
                !this.data.competitionData.nextSlot.forSubscribers &&
                parseInt(this.data.competitionData.freeOccupationsRemaining) > 0 &&
                !this.subscription.isActive &&
                this.data.supplierCanParticipate &&
                this.data.competitionData.hasTag
            );
        },
        freeSubscription() {
            return (
                !this.data.competitionData.nextSlot.forSubscribers &&
                parseInt(this.data.competitionData.freeOccupationsRemaining) > 0 &&
                this.subscription.isActive &&
                this.data.competitionData.hasTag
            );
        },
        offerValue() {
            if (this.freeOffer) {
                return 0;
            } else return this.data.leadPrice;
        },
        filling() {
            return this.subscription.isProduct ? false : this.data.filling;
        },
        cssProps() {
            return {
                '--height-card': !this.isMobile ? '310px' : 'none',
                '--height-text': !this.isMobile ? '40px' : 'none'
            };
        },
        slotsValue() {
            if (
                this.filling ||
                this.data.deleted ||
                !this.data.competitionData.hasSlots ||
                this.data.competitionData.blacklistedEmail ||
                this.data.competitionData.hasValidMeeting
            )
                return 0;
            else return this.data.competitionData.countSlotsRemaining;
        },
        slotsTotal() {
            return this.data.competitionData.supplierMaximumAmountLimit;
        },
        hasClosedSlots() {
            return (
                this.filling ||
                this.data.deleted ||
                !this.data.competitionData.hasSlots ||
                this.data.competitionData.blacklistedEmail ||
                this.data.competitionData.hasValidMeeting
            );
        },
        isExtraSlot() {
            return this.data.competitionData.hasSlotExtra
        }
    }
};
